export enum TripTransportTypeEnum {
  PRIVATE_VEHICLE = 'private_vehicle',
  PUBLIC_TRANSPORT = 'public_transport',
}

export const TripTransportTypeLabels: Record<string, string> = {
  [TripTransportTypeEnum.PRIVATE_VEHICLE]: 'Coche propio',
  [TripTransportTypeEnum.PUBLIC_TRANSPORT]: 'Transporte público',
};
